/* ================================================== */
/* LINKS → Scroll to
/* ================================================== */

function scrollTo(el, offset) {
	offset = typeof offset  === 'undefined' ? 20 : offset;
	var $el = $(el);
	if ($el.length) {
		var page = $('html, body');

		// Stop auto-scroll if user scroll
		page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function() { page.stop() });

		// Auto-scroll
		page.stop(true, true).animate({
			scrollTop: $el.offset().top - offset
		}, 400, function() {
			page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
		});

		return false;
	}
}

$(document).ready(function() {
	$('[data-scroll-to]').click(function(){
		if ($(this).is('[data-offset]')) {
			var offset = $(this).data('offset');
		}
		scrollTo($(this).data('scroll-to'), offset);
	});
});